import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models'

export class TrainingExerciseApiService extends ApiService {
  static async get(query: object): Promise<object> {
    return this.axios.get('training-exercises', { params: query })
      .then((response: AxiosResponse<object>) => response.data)
  }

  static async getAllGroups(): Promise<object> {
    return this.axios.get('training-exercise-groups')
      .then((response: AxiosResponse<object>) => response.data)
  }

  static async saveUserGroup(data: object): Promise<IServiceResponse<object>> {
    return this.axios.post('training-exercise-user-groups', data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async deleteUserGroup(groupId: string): Promise<IServiceResponse<object>> {
    return this.axios.delete(`training-exercise-user-groups/${groupId}`)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async getUserGroups(query: object): Promise<object> {
    return this.axios.get('training-exercise-user-groups', { params: query })
      .then((response: AxiosResponse<object>) => response.data)
  }

  static async createUserExercise(data: object): Promise<IServiceResponse<object>> {
    return this.axios.post('training-exercises', data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async updateUserExercise(exerciseId: string, data: object): Promise<IServiceResponse<object>> {
    return this.axios.put(`training-exercises/${exerciseId}`, data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async deleteUserExercise(exerciseId: string): Promise<IServiceResponse<object>> {
    return this.axios.delete(`training-exercises/${exerciseId}`)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }
}
